/**
 * @generated SignedSource<<369d53091a5c3b2b76a9348f35dc322d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type DashboardAllUnitsQuery$variables = {
  isActive: ActiveRecords;
  targetGroupIsActive?: ActiveRecords | null | undefined;
};
export type DashboardAllUnitsQuery$data = {
  readonly allTargets: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null | undefined;
    readonly summary: string | null | undefined;
    readonly targetGroup: {
      readonly id: string;
    } | null | undefined;
  }>;
};
export type DashboardAllUnitsQuery = {
  response: DashboardAllUnitsQuery$data;
  variables: DashboardAllUnitsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isActive"
  },
  {
    "defaultValue": "BOTH",
    "kind": "LocalArgument",
    "name": "targetGroupIsActive"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "isActive",
            "variableName": "isActive"
          }
        ],
        "kind": "ObjectValue",
        "name": "filter"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "isActive",
            "variableName": "targetGroupIsActive"
          }
        ],
        "kind": "ObjectValue",
        "name": "targetGroupFilter"
      }
    ],
    "concreteType": "TargetNode",
    "kind": "LinkedField",
    "name": "allTargets",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "summary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TargetGroupNode",
        "kind": "LinkedField",
        "name": "targetGroup",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardAllUnitsQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardAllUnitsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a72a9bb831c1202aff75029a1b4fcdaa",
    "id": null,
    "metadata": {},
    "name": "DashboardAllUnitsQuery",
    "operationKind": "query",
    "text": "query DashboardAllUnitsQuery(\n  $isActive: ActiveRecords!\n  $targetGroupIsActive: ActiveRecords = BOTH\n) {\n  allTargets(filter: {isActive: $isActive}, targetGroupFilter: {isActive: $targetGroupIsActive}) {\n    name\n    id\n    summary\n    targetGroup {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "61f22b54412c056a5dd2fa033ec86e60";

export default node;
